import { activityList, advancedFilterResourceList, getResourceLabel } from "utils/utils";

export const resourcesAdvancedSearchKey = "resourcesAdvancedSearchKey";
export const activitiesAdvancedSearchKey = "advancedSearchActivitiesKey";
export const advancedSearchKey = {
    executions: "executionsAdvancedSearchKey",
    messages: "messagesAdvancedSearchKey",
    resources: "resourcesAdvancedSearchKey",
};

export const resourcesTab = "resources";
export const messagesTab = "messages";
export const executionsTab = "executions";
export const initialTab = resourcesTab;

export const getInitialOrder = (activeTab) =>
    activeTab === resourcesTab ? "+name" : "-modified_at";

const initialRowsPerPage = 10;

export const resourceListSorted = advancedFilterResourceList.map((resource) => ({
    label: getResourceLabel(resource),
    value: resource,
}));
export const totalResourcesNumber = advancedFilterResourceList.length;

export const activityListSorted = activityList.map((activity) => ({
    label: getResourceLabel(activity),
    value: activity,
}));
export const totalActivitiesNumber = activityList.length;

export const initialFilter = {
    resource_type: advancedFilterResourceList,
};

const shownOptionsInitialValues = { hide_deleted: true, include_deleted: false };
export const initialAdvancedFilter = {
    resources: { resource_type: advancedFilterResourceList, ...shownOptionsInitialValues },
    executions: { ...shownOptionsInitialValues },
    messages: { ...shownOptionsInitialValues },
};

export const initialQuery = {
    limit: initialRowsPerPage as typeof initialRowsPerPage,
    offset: 0,
    order: "+name",
};

export const rootStyle = {
    maxHeight: "calc(100% - 250px)",
};
